import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IUser } from '@shared/models/iuser.model';
import { FaqService } from '@core/services/faq.service';
import { take } from 'rxjs/operators';
import { Observable } from 'rxjs';

const TABS = {
  faqList: 0,
  createTicket: 1,
};

@Component({
  selector: 'miq-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.scss'],
  standalone: false,
})
export class HelpComponent implements OnInit, OnDestroy {
  public pageId$: Observable<number>;
  public canvas: any; // canvas
  public userInfo: IUser;
  public tabIndex = TABS.faqList;
  public ticket;

  constructor(
    private faqService: FaqService,
    private dialogRef: MatDialogRef<HelpComponent>,
    @Inject(MAT_DIALOG_DATA) data: any
  ) {
    const { canvas, userInfo, options } = data;

    this.canvas = canvas;
    this.userInfo = userInfo;
    this.applyOptions(options);
  }

  ngOnInit() {
    /* required for static lable translation */
    this.pageId$ = this.faqService.currentPageId$.pipe(take(1));
  }

  private applyOptions(options) {
    if (options) {
      const { createTicket, ticketTitle = '', ticketDescription = '' } = options;
      if (createTicket) {
        this.openCreateTicketTab();
      }
      this.ticket = { ticketTitle, ticketDescription };
    }
  }

  public selectedIndexChange(val) {
    this.tabIndex = [TABS.faqList, TABS.createTicket].includes(val) ? val : this.tabIndex;
  }

  openCreateTicketTab() {
    this.selectedIndexChange(TABS.createTicket);
  }

  onClose(event) {
    this.dialogRef.close(event);
  }

  ngOnDestroy() {
    /** label translation purpose added */
  }
}
